import _ from 'lodash';
import restApi from '../modules/app/rest.conf.json';

class Dependencies {
  constructor() {
    this.restSrv = null;
    this.rest = null;
  }

  setDeps(depsArr) {
    Object.keys(depsArr).forEach((key) => {
      this[key] = depsArr[key];
    });
    this.rest = restApi;
  }

  updateSession(session) {
    this.session = _.cloneDeep(session);
  }
}

export default new Dependencies();



// WEBPACK FOOTER //
// ./src/services/dependencies.js